import { RANGES, settings, updateSettings } from "../../../settings";
import type { Settings } from "../../../settings";
import { Slider } from "../../components/Slider";
import { Toggle } from "../../components/Toggle";

export function HudTab() {
  const h = settings.value.hud;
  const set = (patch: Partial<Settings["hud"]>) => updateSettings({ hud: patch });

  return (
    <div class="settings__content">
      <h3 class="settings__group">Layout</h3>
      <div class="settings__rows">
        <Slider
          label="HUD scale"
          description="Size of every HUD element, including the crosshair."
          unit="x"
          {...RANGES.hudScale}
          value={h.scale}
          onChange={(scale) => set({ scale })}
        />
      </div>

      <h3 class="settings__group">Readouts</h3>
      <div class="settings__rows">
        <Toggle label="FPS counter" checked={h.showFps} onChange={(showFps) => set({ showFps })} />
        <Toggle label="Ping" checked={h.showPing} onChange={(showPing) => set({ showPing })} />
        <Toggle
          label="Network graph"
          description="Snapshot rate, jitter and packet loss over time."
          checked={h.showNetGraph}
          onChange={(showNetGraph) => set({ showNetGraph })}
        />
        <Toggle label="Speed meter" checked={h.showSpeed} onChange={(showSpeed) => set({ showSpeed })} />
      </div>

      <h3 class="settings__group">Combat feedback</h3>
      <div class="settings__rows">
        <Toggle
          label="Hit markers"
          description="Marks the crosshair when your shot lands."
          checked={h.hitmarkers}
          onChange={(hitmarkers) => set({ hitmarkers })}
        />
      </div>
    </div>
  );
}
